import { List, ListItem, ListItemText } from '@mui/material'

import { CardWithIcon } from '../../Design/Cards'

import EventIcon from '@mui/icons-material/Event'

const EventsList = ({ eventsInfo, date }) => {
  const dateNow = new Date().toISOString()
  const filteredEvents = eventsInfo?.filter(event => event.end_at >= date) || []
  const numberOfEvents = filteredEvents.length
  const missionsRealisees = filteredEvents.filter(event => event.type_id === process.env.REACT_APP_EVENT_TYPE_MISSIONLYCEE && event.end_at <= dateNow).length
  const interRealisees = filteredEvents.filter(event => event.type_id === process.env.REACT_APP_EVENT_TYPE_INTERVENTION && event.end_at <= dateNow).length
  const interEnCours = filteredEvents.filter(event => event.type_id === process.env.REACT_APP_EVENT_TYPE_INTERVENTION && event.date <= dateNow && event.end_at > dateNow).length
  const interAvenir = filteredEvents.filter(event => event.type_id === process.env.REACT_APP_EVENT_TYPE_INTERVENTION && event.date > dateNow).length

  return (
    <div style={{ flex: 1 }}>
      <CardWithIcon
        to="/events"
        icon={EventIcon}
        title="Évènements"
        subtitle={numberOfEvents}
        color="#57aaa6"
      >
        <List>
          <ListItem>
            <ListItemText primary="Missions lycée réalisées" secondary={missionsRealisees} />
          </ListItem>

          <ListItem>
            <ListItemText primary="Interventions réalisées" secondary={interRealisees} />
          </ListItem>

          <ListItem>
            <ListItemText primary="Interventions en cours" secondary={interEnCours} />
          </ListItem>

          <ListItem>
            <ListItemText primary="Interventions à venir" secondary={interAvenir} />
          </ListItem>
        </List>
      </CardWithIcon>
    </div>
  )
}

export default EventsList